<div
  class="ratingDetailsPageWrapper"
>
  <app-page-header></app-page-header>
  <app-rating-details-table></app-rating-details-table>
</div>
